import {LazyLoadContext} from './LazyLoadContext';
import {LazyLoadWrapperProps} from './LazyLoadWrapper.interface';
import {useLazyLoad} from './useLazyLoad.hook';

function LazyLoadWrapperMain({
  disabled,
  options,
  children,
}: LazyLoadWrapperProps) {
  const {memoizedContext} = useLazyLoad({disabled, options});

  return (
    <LazyLoadContext.Provider value={memoizedContext}>
      {children}
    </LazyLoadContext.Provider>
  );
}

export const LazyLoadWrapper = LazyLoadWrapperMain;
